import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsShopifyComponent } from './simple-icons-shopify.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsShopifyComponent ],
    exports:      [ SimpleIconsShopifyComponent ],
    bootstrap:    []
})
export class SimpleIconsShopifyModule {}
